import { BaseDeregistration } from "./tasks";

export class Deregistration extends BaseDeregistration {
    constructor() {
        super();
        this.referenceId = null;
    }
}
